<template>
  <div class="mb10">
    {{ label }}
  </div>
</template>
<script>
export default {
  props: ['label'],
}
</script>
